import isEmpty from 'lodash/isEmpty'
import { ProductInstructions } from '@/features/shop/components/ProductInstructions'
import { Button } from '@shipt/design-system-buttons'
import { useQueryPreference } from '@/features/shop/services/Substitutions/queries'

type Props = {
  note: string
  product: { id: number; oos: boolean } | null
  productQuantity: number
  handleOpenModal: () => void
}

export const ProductDetailInstructions = ({
  note = '',
  product,
  productQuantity,
  handleOpenModal,
}: Props) => {
  const { oos = false, id } = product ?? {}
  const { data: substitutionPreference = {} } = useQueryPreference(id || 0)
  const hasInstructions = note.length > 0
  const hasSubstitutionPreference = !isEmpty(substitutionPreference)

  const showInstructions = !oos && (hasInstructions || hasSubstitutionPreference)
  const isNoteButtonEnabled = Boolean(productQuantity) || !oos

  return showInstructions ? (
    <ProductInstructions
      note={note}
      backup={substitutionPreference}
      handleOpenModal={handleOpenModal}
    />
  ) : (
    <Button variant="secondary" fullWidth disabled={!isNoteButtonEnabled} onClick={handleOpenModal}>
      Add note or backup
    </Button>
  )
}
